export type LinkedProfile = {
  id: string;
  firstName: string;
  middleName?: string;
  lastName: string;
  patientId: string;
  status: string;
  email?: string;
  primaryNumber?: string;
  programs?: string[];
  organizationName?: string;
  dateOfBirth?: string;

};

export type LoggedType = "email" | "phone";

export type UserSwitchSessionDataType = {
  token: string;
  // activePatientId: string;
  linkedProfiles: LinkedProfile[];
  loggedType?: LoggedType;
  // redirectTo?: string;
};

export const USER_SWITCH_SESSION_DATA = "userSwitchSessionData";
export const LOGGED_TYPE_KEY = "loggedType";

export function getLoggedTypeFromIdentifier(identifier: string): LoggedType {
  const v = String(identifier ?? "").trim();
  if (!v) return "email";
  if (v.includes("@")) return "email";
  const phoneCandidate = v.replace(/[ \-()]/g, "");
  if (/^[+]?\d+$/.test(phoneCandidate) && phoneCandidate.replace(/\D/g, "").length >= 10) {
    return "phone";
  }
  return "email";
}

export function resolveLoggedType(
  identifier: string,
  options?: { loginAsOther?: boolean; apiType?: unknown },
): LoggedType {
  if (options?.apiType === "phone" || options?.apiType === "email") {
    return options.apiType;
  }
  if (options?.loginAsOther) return "email";
  return getLoggedTypeFromIdentifier(identifier);
}

export function writeLoggedType(type: LoggedType) {
  localStorage.setItem(LOGGED_TYPE_KEY, type);
}

export function readLoggedType(): LoggedType | null {
  const value = localStorage.getItem(LOGGED_TYPE_KEY);
  return value === "email" || value === "phone" ? value : null;
}

export function getLoggedTypeOrDefault(
  sessionLoggedType?: LoggedType | null,
): LoggedType {
  return sessionLoggedType ?? readLoggedType() ?? "email";
}

export const DEMO_LINKED_PROFILES: LinkedProfile[] = [
  {
    id: "64f000000000000000000001",
    firstName: "John",
    lastName: "Doe",
    patientId: "P001",
    status: "active",
  },
  {
    id: "64a000000000000000000002",
    firstName: "Jane",
    lastName: "Doe",
    patientId: "P002",
    status: "active",
  },
];

export function readUserSwitchSessionData(): UserSwitchSessionDataType | null {
  try {
    const raw = sessionStorage.getItem(USER_SWITCH_SESSION_DATA);
    if (!raw) return null;
    return JSON.parse(raw) as UserSwitchSessionDataType;
  } catch {
    return null;
  }
}

export function writeUserSwitchSessionData(session: UserSwitchSessionDataType) {
  sessionStorage.setItem(USER_SWITCH_SESSION_DATA, JSON.stringify(session));
}

export function clearUserSwitchSessionData() {
  sessionStorage.removeItem(USER_SWITCH_SESSION_DATA);
}
